import { render, staticRenderFns } from "./IRChipGroup.vue?vue&type=template&id=1ebfcab6&scoped=true"
import script from "./IRChipGroup.vue?vue&type=script&lang=js"
export * from "./IRChipGroup.vue?vue&type=script&lang=js"
import style0 from "./IRChipGroup.vue?vue&type=style&index=0&id=1ebfcab6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ebfcab6",
  null
  
)

export default component.exports